// Removing a step property must also drop every step that comes after it in the step order
// (Серия → Модель → Объём → Цвет → Тип SIM). Non-step blocks remove only themselves.
export const getCascadeCodesToRemove = (code: string, stepCodes: string[]): string[] => {
	const index = stepCodes.indexOf(code)
	if (index === -1) return [code]

	return stepCodes.slice(index)
}
